import { createTypedSxStyles, capitalDesignTokens } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
	editIcon: {
		"&:hover": {
			cursor: "pointer",
		},
		"& .MuiSvgIcon-root": {
			height: "14px",
			width: "14px",
			color: capitalDesignTokens.semanticColors.callToAction.primaryActionMedium,
		}
	},
	addEventButtonContainer: {
		display: "flex",
		justifyContent: "flex-start"
	},
	previewSwitchContainer: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		gap: "8px"
	},
	orientationToggleContainer: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "center",
		gap: "8px",
		marginRight: "16px"
	},
	progressTrackerContainer: {
		border: "none",
		outline: "none"
	},
	textField: {
		height: "32px",
		border: "none",
		paddingBottom: "16px",
		"& .MuiOutlinedInput-root": {
			margin: "0px",
			minHeight: "32px"
		},
		"& .MuiOutlinedInput-root > input": {
			border: "none"
		}
	},
	eventsDetailsContainer: {
		display: "flex",
		alignItems: "center",
		gap: "8px"
	},
	statusColor: {
		width: "16px",
		height: "16px",
		borderRadius: "1px"
	},
	selectStatus: {
		height: "32px",
		margin: "0px !important"
	},
	closeIcon: {
		"&:hover": {
			cursor: "pointer",
			backgroundColor: "transparent"
		},
		width: "16px",
		height: "16px",
		padding: "0px"
	},
	statusContainer: {
		display: "flex",
		alignItems: "center",
		gap: "8px",
		textTransform: "capitalize"
	},
	titleTextField: {
		width: "200px",
		height: "32px",
		"& .MuiOutlinedInput-root": {
			margin: "0px",
		},
		"& .MuiOutlinedInput-root > input": {
			border: "none"
		}
	},
	addEventButton: {
		textTransform: 'none',
		'&:hover': {
			cursor: 'pointer',
			backgroundColor: 'transparent'
		},
		paddingTop: "16px"
	},
	gridContainer: {
		padding: "24px 16px 0px 16px",
	},
	progressTrackerBox: {
		display: "flex",
		alignItems: "center",
		gap: "8px",
		justifyContent: "space-between"
	},
	headerContainer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	eventRowContainer: {
		alignItems: "center"
	},
	eventListHeader: {
		display: "flex",
		alignItems: "center",
		gap: "8px",
		justifyContent: "space-between"
	},
	previewToggleContainer: {
		display: "flex",
	}
});
